<template>
  <div class="manager-tab" @click.stop="activateModal">
    <img :src="item.headshot" class="manager-tab__thumbnail" />
    <div class="manager-tab__identity">
      <h5 class="identity__position">{{ customTitle.length ? customTitle : item.title }}</h5>
      <h5 class="identity__name">{{ item.name }}</h5>
    </div>
    <div class="manager-tab__icon"><i class="fa fa-chevron-right"></i></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ContactTeamItem',
    components: {},
    props: {
      item: {
        type: Object,
      },
      modalKey: {
        type: String,
        default: '',
      },
      customTitle: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapGetters('main', ['fuelEmployee']),
    },
    methods: {
      activateModal() {
        if (this.fuelEmployee) {
          alert('This functionality is reserved for members only.');
        } else {
          this.$store.dispatch('main/showModal', this.modalKey);
        }
      },
    }
  };
</script>
